import { useEffect, useState } from "react";

/**
 * Returns true only after `active` has stayed true for `delayMs`; flips back to false immediately
 * when `active` clears. Used to gate the loading overlay so fast (warm-cache) fetches keep the
 * complete previous view and never flash the loader, while slower loads show it.
 */
export function useDelayedFlag(active: boolean, delayMs = 250): boolean {
  const [shown, setShown] = useState(false);
  useEffect(() => {
    if (!active) {
      setShown(false);
      return undefined;
    }
    const id = setTimeout(() => setShown(true), delayMs);
    return () => clearTimeout(id);
  }, [active, delayMs]);
  return shown;
}
